<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-cash-register"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingExpense"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-menu
                      v-model="registerAtMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="expense.registerAt"
                        >
                          <v-text-field
                            v-model="expense.registerAt"
                            :label="$t('fields.expense.registerAt')"
                            hint="MM/DD/YYYY"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            readonly
                            :error-messages="errors"
                            v-on="on"
                          />
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="expense.registerAt"
                        no-title
                        :locale="$i18n.locale"
                        @input="registerAtMenu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="expense.cashDeskId"
                        >
                          <v-select
                            v-model="expense.cashDeskId"
                            :items="cashDesks"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.expense.cashDeskId')"
                            :error-messages="errors"
                            outlined
                            @change="getCashDeskItems"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <v-select
                          v-model="expense.cashDeskItemId"
                          :items="cashDeskItems"
                          item-text="name"
                          item-value="id"
                          :label="$t('fields.expense.cashDeskItemId')"
                          outlined
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="expense.expenseCategoryId"
                        >
                          <v-select
                            v-model="expense.expenseCategoryId"
                            :items="categories"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.expense.expenseCategoryId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="expense.amount"
                        >
                          <v-text-field
                            v-model.number="expense.amount"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.expense.amount')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:250"
                          name="expense.comment"
                        >
                          <v-text-field
                            v-model="expense.comment"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.expense.comment')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const expenseCategoriesRepository = repositoryFactory.get('expenseCategories')
  const cashDesksRepository = repositoryFactory.get('cashDesks')
  const cashDeskItemsRepository = repositoryFactory.get('cashDeskItems')
  const expensesRepository = repositoryFactory.get('expenses')

  export default {
    inject: ['theme'],
    name: 'ExpenseRegister',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      expense: {

      },
      categories: [],
      cashDesks: [],
      cashDeskItems: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingExpense: false,
      loadingSave: false,
      formAction: null,
      registerAtMenu: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-expense') : this.$t('modify-expense')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingExpense = true
        var id = this.$route.params.id
        expensesRepository.getById(id).then(response => {
          self.loadingExpense = false
          self.expense = Object.assign({}, response.data.data)
          self.getCashDeskItems()
        }).catch(err => {
          self.loadingExpense = false
          alert(err)
        })
      }
      this.getCategories()
      this.getCashDesks()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.expense,
          userId: this.$store.state.user.id,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          expensesRepository.updateExpense(data, this.expense.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        } else {
          expensesRepository.addExpense(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      getCategories () {
        var self = this
        expenseCategoriesRepository.get().then(response => {
          self.categories = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getCashDesks () {
        var self = this
        cashDesksRepository.get().then(response => {
          self.cashDesks = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getCashDeskItems () {
        var self = this
        cashDeskItemsRepository.getByCashDesk(self.expense.cashDeskId).then(response => {
          self.cashDeskItems = response.data.data
          self.cashDeskItems.splice(0, 0, { id: null, name: '--' })
        }).catch(err => {
          alert(err)
        })
      },
      goToList () {
        this.$router.push({ name: 'expenses' })
      },
    },
  }
</script>
